<template>
    <div>
        <form
            v-on:submit="submitForm({ entryForm: state.entryForm })"
        >
            <div>
                <div
                    class="image-field mb-5"
                >
                    <label class="file-label">
                        Cover Image <span class="red">*</span>
                    </label>
                    <div class="d-block">
                        <input
                            id="upload"
                            ref="upload"
                            type="file"
                            accept="image/*"
                            v-on:change="handleImageUploadChange"
                            v-on:click="(event)=> {
                              event.target.value = null
                            }"
                        />
                    </div>
                    <div
                        style="max-width: 587px;"
                    >
                        <img
                            v-if="state.entryForm.image.value"
                            :src="state.entryForm.image.value"
                        />
                        <img
                            v-else-if="props.formData.main_image"
                            :src="props.formData.main_image.full"
                        />
                    </div>
                </div>
                <input-text-field
                    :vuelidate="v$.entryForm.title"
                    id="title"
                    label="Title of Contest"
                    placeholder="Cover Search Contest 2023"
                ></input-text-field>
                <input-text-field
                    :vuelidate="v$.entryForm.slug"
                    id="slug"
                    label="Contest Slug"
                    placeholder="cover-search-contest-2023"
                ></input-text-field>
                <select-field
                    :vuelidate="v$.entryForm.status"
                    :options="['submit', 'vote', 'completed']"
                    id="status"
                    label="Status"
                ></select-field>
                <select-field
                    :vuelidate="v$.entryForm.type"
                    :options="['cover_search_contest', 'pet_contest']"
                    id="type"
                    label="Type"
                ></select-field>
                <input-date-time-field
                    :vuelidate="v$.entryForm.submit_start"
                    id="submit_start"
                    label="Contest Start Date"
                ></input-date-time-field>
                <input-date-field
                    :vuelidate="v$.entryForm.completed_start"
                    id="completed_start"
                    label="Contest End Date"
                ></input-date-field>
                <input-text-field
                    :vuelidate="v$.entryForm.hubspot_form_id"
                    id="hubspot_form_id"
                    label="Hubspot Form ID"
                    placeholder="fa399610-6cfd-4844-9f44-c54bc5dc8448"
                ></input-text-field>
                <div
                    class="text-4xl mb-5"
                >
                    Contest Pages
                </div>
                <input-text-field
                    :vuelidate="v$.entryForm.enter_title"
                    id="enter_title"
                    label="Enter Page Title"
                    placeholder="We’re Looking For Amazing NJ Images"
                ></input-text-field>
                <editor-field
                    :vuelidate="state.entryForm.enter_content"
                    id="enter_content"
                    label="Enter Page Content"
                    :update="updateEditor"
                ></editor-field>
                <editor-field
                    :vuelidate="state.entryForm.gallery_content"
                    id="gallery_content"
                    label="Gallery Page Content"
                    :update="updateEditor"
                ></editor-field>
                <editor-field
                    :vuelidate="state.entryForm.rules_content"
                    id="rules_content"
                    label="Rules Page Content"
                    :update="updateEditor"
                ></editor-field>
                <editor-field
                    :vuelidate="state.entryForm.tips_content"
                    id="tips_content"
                    label="Tips Page Content"
                    :update="updateEditor"
                ></editor-field>
                <text-area-field
                    :vuelidate="v$.entryForm.prizes_content"
                    id="prizes_content"
                    label="Prizes Page Content"
                    @input="(e) => setInput(e, 'prizes_content')"
                    :value="state.entryForm.prizes_content"
                ></text-area-field>
            </div>
            <div class="text-center_content full-width">
                <span class="scroll btn btn-primary" v-on:click="submitForm({ entryForm: state.entryForm })">
                    {{ props.update ? 'Update' : 'Create' }} Contest
                </span>
            </div>
        </form>
    </div>
</template>


<script setup>
import {API_URL, S3_URL, ENV_URL} from '../../environment.js';
import vSelect from '../vue-select';
import { email, required, minLength, maxLength, sameAs, helpers } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import InputTextField from "@/js/components/fields/InputTextField";
import InputDateTimeField from "@/js/components/fields/InputDateTimeField";
import EditorField from "@/js/components/fields/EditorField";
import SelectField from "@/js/components/fields/SelectField";
import { reactive, computed, onMounted} from "vue";
import { useStore } from 'vuex'
import TextAreaField from "../fields/TextAreaField.vue";

const store = useStore()
const state = reactive({
    open: true,
    S3_URL: S3_URL,
    count: 1,
    makingRequest: false,
    title: '',
    entryForm: {
        image: {
            value: null,
        },
        title: '',
        status: '',
        type: '',
        slug: '',
        submit_start: '',
        completed_start: '',
        enter_title: '',
        enter_content: '',
        gallery_content: '',
        rules_content: '',
        tips_content: '',
        prizes_content: '',
        hubspot_form_id: '',

    },
});
const props = defineProps({
    submitForm: {
        type: Function,
        required: true,
    },
    update: {
        type: Boolean,
        default: false,
    },
    formData: {
        type: Object,
        default: {},
    }
})
const notRequired = () => true;
const rules =  {
        entryForm: {
            image: {
                value: { required }
            },
            title: { required },
            slug: { required },
            status: { required },
            type: { required },
            submit_start: { required },
            completed_start: { required },
            enter_title: { notRequired },
            enter_content: { notRequired },
            gallery_content: { notRequired },
            rules_content: { notRequired },
            tips_content: { notRequired },
            prizes_content: { notRequired },
            hubspot_form_id: { notRequired },
        }
    }
const v$ = useVuelidate(rules, state);

const contest = computed(() => store.state.contest)
const loading = computed(() => store.state.loading)
const entry = computed(() => store.state.entry)
const user = computed(() => store.state.user)

const updateEditor = (id, content) => {
    state.entryForm[id] = content;
}
const setInput = (e, field) => {
    state.entryForm[field] = e.target.value;
}
const handleImageUploadChange = (e) => {
    // add the uploaded image to the input
    const reader = new FileReader();
    const file = e.target.files[0];
    const file_size = file.size;
    if (file_size > 10000000) {
        alert('Your file is too big (' + file_size / 1000000 + 'mb). Please upload an image less than 10mb.');
        return;
    }
    reader.onload = (upload) => {
        var img = new Image();
        img.src = reader.result;
        img.onload = function (e) {
            console.log('handleImageUploadChange', upload.target.result, file.name)

            state.entryForm.image.value = upload.target.result;
            state.entryForm.image.filename = file.name;
            state.entryForm.image.filetype = file.type;
            // this.$store.dispatch('ENTRY_FORM', {entryForm: form});
        }.bind(this);
    };
    reader.readAsDataURL(file);
}


onMounted(() => {
    if (props.formData.title) {
        state.entryForm.title = props.formData.title ?? '';
        state.entryForm.slug = props.formData.slug ?? '';
        state.entryForm.status = props.formData.status ?? '';
        state.entryForm.type = props.formData.type ?? '';
        state.entryForm.enter_title = props.formData.enter_title ?? '';
        state.entryForm.submit_start = props.formData.submit_start ?? '';
        state.entryForm.completed_start = props.formData.completed_start ?? '';
        state.entryForm.enter_content = props.formData.enter_content ?? '';
        state.entryForm.gallery_content = props.formData.gallery_content ?? '';
        state.entryForm.rules_content = props.formData.rules_content ?? '';
        state.entryForm.tips_content = props.formData.tips_content ?? '';
        state.entryForm.prizes_content = props.formData.prizes_content ?? '';
        state.entryForm.hubspot_form_id = props.formData.hubspot_form_id ?? '';
        state.entryForm.media_id = props.formData.media_id ?? '';
    }
})


</script>

<style lang="scss" scoped>
.v-select .dropdown-menu {
    text-transform: capitalize;
}

#covered-image {
    position: relative;
    overflow: hidden;
}

#user-image {
    position: absolute;
}

.v-select.single .selected-tag {
    text-transform: capitalize;
}

.category {
    font-size: 1.3em;
}
</style>
